import { render } from "./TemplateDemandBooking4.vue?vue&type=template&id=f4e4964a"
import script from "./TemplateDemandBooking4.vue?vue&type=script&lang=js"
export * from "./TemplateDemandBooking4.vue?vue&type=script&lang=js"
script.render = render

export default script